<div>
    <div class="content-container">
      <mat-icon id="close-icon" (click)="closeDialog()">close</mat-icon>
      <span class="content-span full-width">{{data.message}}</span>
    </div>
    <button mat-flat-button id="yes-button" [mat-dialog-close]="true">YES</button>
    <button mat-flat-button id="no-button" [mat-dialog-close]="false">NO</button>   
  </div>
